module.exports = __webpack_public_path__ + "media/images/icon-profile-b5e4d1f596b0c69f7ce5740d217bd0f3.svg";